import baseRequest from './baseRequest';

export const fetchAllSponsors = () => {
    const url = '/new-ops/sponsors';
    const mehod = 'GET';
    return baseRequest(url, mehod, null, null);
};

// Search the dope entities for the online-consultation wallet flow. The
// operator searches/picks an entity; sponsorId is derived from the chosen
// entity. Returns [{ entityId, entityName, sponsorId }].
export const searchDopeEntities = (search = '') => {
    const url = '/new-ops/dope-entities';
    const method = 'GET';
    // Only send the search param when the operator actually typed something.
    const trimmed = (search || '').trim();
    const query = trimmed ? { search: trimmed } : null;
    return baseRequest(url, method, query, null);
};

export const fetchAppointmentPreference = () => {
    const url = '/new-ops/appointment-preference-options';
    const mehod = 'GET';
    return baseRequest(url, mehod, null, null);
};

export const fetchCallbackList = () => {
    const url = '/new-ops/offline-consult/active-callbacks-requests';
    const method = 'GET';
    return baseRequest(url, method, null, null);
};

export const fetchCallbackLogs = () => {
    const url = '/new-ops/offline-consult/callback-requests-call-logs';
    const method = 'GET';
    return baseRequest(url, method, null, null);
};
